// This file is AUTOGENERATED, do not edit it manually!!!

export const inlineEdit = {
    action_has_been_successfully_undone: '{0} a été annulé avec succès',
    action_has_not_been_successfully_undone: 'Nous sommes désolés, mais nous n\'avons pas pu annuler l\'action.',
    action_will_be_undo_message: 'L\'action sera annulée : {0}',
    ActivityChildrenActualHours_Text: 'Feuilles de temps pour toutes les sous-activités :',
    ActivityChildrenEstimatedHours_Text: 'Heures estimées pour toutes les sous-activités :',
    ActivityOwnBudget_Text: 'Budget pour l\'activité :',
    ActivityOwnEstimatedHours_Text: 'Heures estimées pour l\'activité :',
    ActivitySubactivitiesBudget_Text: 'Budget pour toutes les sous-activités :',
    ActualCompletion_Text: 'Achèvement réel',
    ActualHours_Total_Text: 'Heures réellement passées, total :',
    AddTimeEntry_Text: 'Ajouter une entrée de temps',
    AddUser_Text: 'Inviter un utilisateur',
    AddWeeklyTime_Text: 'Ajouter un temps hebdomadaire',
    Apply: 'Appliquer',
    Assignees_Text: 'Attribués',
    BudgetedCost_Text: 'Budget total du projet :',
    BudgetPadding_Text: 'Provisions :',
    BudgetTotal_Text: 'Budget, total :',
    Cancel: 'Annuler',
    Close: 'Fermer',
    Combobox_Add: 'Ajouter ',
    Combobox_KeepTyping: 'Continuez à taper...',
    Combobox_MultipleSelectDefault: 'Sélectionnez des options',
    Combobox_NoResults: 'Aucun résultat',
    Combobox_NoResultsMatch: 'Aucun résultat correspondant à ',
    confirmation_description_dependent_date: 'Vous êtes sur le point de modifier la date d\'une activité ayant des dépendances. Cette action ajustera les décalages de dépendance pour s\'aligner sur la nouvelle date indiquée.',
    confirmation_title_dependent_date: 'Cette date est liée à une activité dépendante',
    Cost_Text: 'Facturation :',
    CreateAndSelect: 'Créer et sélectionner',
    CustomerLabel: 'Client',
    day_template: '1#{0} jour#{0} jours',
    Duration_Text: 'Durée',
    EditProjectMembers_Title: 'Membres du projet',
    EditTaskAssignees_Title: 'Attribués',
    End_Text: 'Fin',
    EndDate_Text: 'Date de fin',
    EstimatedHours_Text: 'Heures estimées :',
    EstimatedHours_Total_Text: 'Heures estimées, total :',
    field_for_all_activities: 'Ce champ est réservé aux activités seulement <b style=\"white-space: nowrap;\">({0} tâches, {1} problèmes, {2} demandes)</b>',
    field_for_issues: 'Ce champ est réservé à <b style=\"white-space: nowrap;\">{0} problèmes</b> seulement',
    field_for_projects: 'Ce champ est réservé à <b style=\"white-space: nowrap;\">{0} projets</b> seulement',
    field_for_requests: 'Ce champ est réservé à <b style=\"white-space: nowrap;\">{0} demandes</b> seulement',
    field_for_tasks: 'Ce champ est réservé à <b style=\"white-space: nowrap;\">{0} tâches</b> seulement',
    Hours_Short_Text: 'h',
    HoursLeftLabel: 'Heures restantes :',
    InternalCost_Text: 'Coût réel :',
    NonProjectMembers_Text: 'Non-membres du projet',
    Not_Space_Members: 'Non membres de l\'espace',
    Overloaded_Text: 'Surchargé',
    OwnActualHours_Text: 'Feuilles de temps pour l\'activité :',
    PlannedExpenses_Text: 'Dépenses prévues :',
    PortfolioLabel: 'Portefeuille',
    Progress: 'Progression',
    ProgressCalculatedBySubActivities: 'Basé sur la progression des sous-activités',
    ProjectChildrenActualHours_Text: 'Feuilles de temps pour les activités :',
    ProjectChildrenEstimatedHours_Text: 'Heures estimées pour toutes les activités :',
    ProjectMembers_Text: 'Membres du projet',
    ProjectOwnBudget_Text: 'Budget de main d’œuvre pour le projet :',
    ProjectOwnEstimatedHours_Text: 'Heures estimées pour le projet :',
    ProjectSubactivitiesBudget_Text: 'Budget pour toutes les activités :',
    Space_Members: 'Membres de l\'espace',
    Start_Text: 'Début',
    StartDate_Text: 'Date de début',
    Teams_Text: 'Équipes',
    Timelogs_In_Past: 'La modification du temps pour une activité qui a eu lieu il y a plus de {0} n\'est pas recommandée. Êtes-vous sûr de vouloir continuer ?',
    Timelogs_In_Past_Short: 'La modification du temps pour une activité qui a eu lieu il y a plus de {0} n\'est pas recommandée',
    TimeLogs_Warning_Project_Closed: 'Ajouter du temps à un projet clôturé n\'est pas recommandé. Êtes-vous sûr de vouloir ajouter du temps à ce projet clôturé ?',
    TimeLogs_Warning_Project_Closed_Short: 'Ajouter du temps à un projet clôturé n\'est pas recommandé',
    TimeLogs_Warning_Task_Closed: 'Ajouter du temps à une activité clôturée n\'est pas recommandé. Êtes-vous sûr de vouloir ajouter du temps à cette activité clôturée ?',
    TimeLogs_Warning_Task_Closed_Short: 'Ajouter du temps à une activité clôturée n\'est pas recommandé',
    Tooltip_Dependent_Template: '{0} est lié à une activité dépendante et ne peut pas être modifié',
    Tooltip_HasChildren_Template: '{0} est calculé selon les sous-activités et ne peut pas être modifié',
    Tooltip_ItemCompleted: 'Impossible de modifier, car cette action est liée à une activité/projet clôturé.',
    Tooltip_NoRightForUserRole_Template: '{0} ne peut pas être modifié. Vous n\'avez pas l\'autorisation de modifier ce champ',
    Tooltip_Open_Details: 'Veuillez ouvrir les détails pour modifier ce champ',
    undo_action_Project_UpdateActualCompletionDate: 'modification de la date d’achèvement réelle du projet',
    undo_action_Project_UpdateDates: 'modification des dates du projet',
    undo_action_Project_UpdateName: 'renommage du projet',
    undo_action_Project_UpdateStatus: 'modification du statut du projet',
    undo_action_Task_UpdateActualCompletionDate: 'modification de la date d’achèvement réelle de l\'activité',
    undo_action_Task_UpdateDates: 'modification des dates de l\'activité',
    undo_action_Task_UpdateDependencies: 'modification de la dépendance',
    undo_action_Task_UpdateName: 'renommage de l\'activité',
    undo_action_Task_UpdateStatus: 'modification du statut de l\'activité',
    undo_action_Task_UpdateWorkIsDone: 'définition de « J\'ai terminé » pour l\'attribution de la tâche',
    Untitled: 'Sans titre',
    Validation_ActComplDateRange: 'La date d’achèvement réelle ne se situe pas dans la plage attendue.',
    Validation_DateMandatory: 'La date est un champ obligatoire.',
    Validation_DurationMandatory: 'La durée est un champ obligatoire.',
    Validation_EndDateRange: 'La date de fin ne se situe pas dans la plage attendue.',
    Validation_FieldMandatory: 'Ce champ est obligatoire.',
    Validation_FromDateRange: 'La date de début ne se situe pas dans la plage attendue.',
    Validation_Interger: 'La valeur doit être un entier.',
    Validation_InvalidDate: 'La date doit être au format \'{0}\'.',
    Validation_NumberRange: 'La valeur doit être comprise entre {0} et {1}.',
    Validation_Range: 'La valeur ne se situe pas dans la plage attendue.',
    Validation_StartDateRange: 'La date de début ne se situe pas dans la plage attendue.',
    Validation_ToDateRange: 'La date de fin ne se situe pas dans la plage attendue.',
    Validation_WeekendOrVacation: 'La valeur ne doit pas tomber un week-end ou un jour férié.',
    Warning_UnassigneFromAllTasksInProject: 'Les membres supprimés seront retirés de toutes les activités de ce projet.',
    Warning_UnassignFromAllTasksInProject_Single: 'Le membre supprimé sera retiré de toutes les activités de ce projet.',
};
